import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FreeSignupFlow } from '../auth/FreeSignupFlow';
import { TrialSubscriptionFlow } from '../auth/TrialSubscriptionFlow';
import { PaidSignupFlow } from '../auth/PaidSignupFlow';
import { TokenSignupFlow } from '../auth/TokenSignupFlow';
import { logError, logInfo } from '../../utils/logger';

export const SubscriptionFlow = () => {
  console.log('[SubscriptionFlow] Component rendered');
  const navigate = useNavigate();
  const { plan } = useParams();
  
  useEffect(() => {
    console.log('[SubscriptionFlow] Plan from URL:', plan);
    
    const validPlans = ['free', 'beta', 'professional', 'enterprise', 'tokens'];
    if (!validPlans.includes(plan)) {
      console.log('[SubscriptionFlow] Invalid plan, redirecting to plans');
      navigate('/plans', { replace: true });
      return;
    }
  }, [plan, navigate]);

  if (!plan) {
    console.log('[SubscriptionFlow] No plan selected, rendering null');
    return null;
  }

  console.log('[SubscriptionFlow] Rendering flow for plan:', plan);

  // Render appropriate signup flow based on plan
  switch (plan) {
    case 'free':
      return <FreeSignupFlow />;
    case 'beta':
      return <TrialSubscriptionFlow />;
    case 'professional':
    case 'enterprise':
      return <PaidSignupFlow plan={plan} />;
    case 'tokens':
      return <TokenSignupFlow />;
    default:
      console.log('[SubscriptionFlow] Invalid plan state, redirecting to plans');
      navigate('/plans', { replace: true });
      return null;
  }
};